import React, { useState, useEffect } from 'react';
import { FactSheetService } from '../../services/FactSheetService';
import CookieManager from '../../utils/CookieManager';
import { mdlFactSheetLanguageItem } from "../../models/service-models/fact-sheet/FactSheetLanguageItem";
import { Select } from 'antd';

const FactSheetLanguageDropdown = ({ onChange }: { onChange: (language: string) => void }) => {
    const [languages, setLanguages] = useState<mdlFactSheetLanguageItem[]>([]);
    const [currentLanguage, setCurrentLanguage] = useState(CookieManager.get("language") || "en-US");

    useEffect(() => {
        const fetchLanguages = async () => {
            const langs = await FactSheetService.GetLanguages({});
            setLanguages(langs?.body?.data || []);
            onChange(currentLanguage);
        };

        fetchLanguages();
    }, []);

    const handleLanguageChange = (lang: any) => {
        setCurrentLanguage(lang);
        onChange(lang);
    };

    
    const getFormattedLanguageCode = (languageCode:string) => {
        if(languageCode.includes("-"))
            return languageCode;
        const languageMap = {
          "tr": "tr-TR",
          "en": "en-US",
          "es": "es-ES",
          "es-419": "es-419",
          "et": "et-EE",
          "fa": "fa-IR",
          "fi": "fi-FI",
          "fr": "fr-FR",
          "he": "he-IL",
          "hi": "hi-IN",
          "hr": "hr-HR",
          "hu": "hu-HU",
          "in": "in-ID",
          "it": "it-IT",
          "ja": "ja-JP",
          "ko": "ko-KR",
          "lt": "lt-LT",
          "lv": "lv-LV",
          "ms": "ms-MY",
          "nl": "nl-NL",
          "no": "no-NO",
          "pl": "pl-PL",
          "pt": "pt-PT",
          "ro": "ro-RO",
          "ru": "ru-RU",
          "sk": "sk-SK",
          "sl": "sl-SI",
          "sr": "sr-RS",
          "sv": "sv-SE",
          "th": "th-TH",
          "uk": "uk-UA",
          "vi": "vi-VN",
          "zh-cmn-Hans": "zh-cmn-Hans",
          "zh-cmn-Hant": "zh-cmn-Hant",
          "ar": "ar-SA",
          "bg": "bg-BG",
          "ca": "ca-ES",
          "cs": "cs-CZ",
          "da": "da-DK",
          "de": "de-DE",
          "el": "el-GR"
        };
        return languageMap[languageCode as keyof typeof languageMap] || `${languageCode}-${languageCode}`;
    }

    return (
        <Select
            style={{ width: '150px', textAlign: 'left' }}
            value={currentLanguage}
            onChange={handleLanguageChange}
            options={languages.map((lang: any) => ({
                value: lang.id,
                label: lang.name
            }))}
        />
    );
};

export default FactSheetLanguageDropdown;
